import React from 'react';
import { format_curency } from 'utils';

const VerticalGift = ({ isMobile, giftData, handleOpenDetailInfo }) => (
  <div className='h-fit w-fit p-1 lg:p-0' onClick={() => handleOpenDetailInfo(giftData)}>
    <div
      className={`block ${
        isMobile ? 'drop-shadow-[0_3px_3px_rgba(0,0,0,0.2)]' : ''
      } mb-0 w-[160px] cursor-pointer overflow-hidden rounded-lg bg-white`}
    >
      <div className='flex justify-center items-center h-[108px] w-full'>
        <img
          className='h-[100%] rounded-t-lg object-contain lg:rounded-none'
          src={giftData.imageLink[0]?.fullLink || '/assets/images/carousel/pc/Voucher2.png'}
          alt=''
        />
      </div>
      <div className='px-4 py-5 pb-2 font-roboto-regular'>
        <p className='line-clamp-2 text-[16px]'>{giftData.giftInfor.name}</p>
        <p className='line-clamp-2 text-14px text-0090F0'>
          {format_curency(giftData.giftInfor.requiredCoin)} điểm
        </p>
      </div>
    </div>
  </div>
);

export default VerticalGift;
